// extracted by mini-css-extract-plugin
export default {"refresh":"Animation_refresh__XMmi-","spin":"Animation_spin__C84e2"};